export default __webpack_public_path__ + "static/card-index-middle-1-db7a63d2d5a2f81d42c9507f51453cfe.jpg";